// 几个疑问
// 判断来源时 有 yahoo 和 soso,搜索的时候没有
// sdk 判断用的值为 'sdk'，搜索的时候用的 'appsdk'

const DIRECT = 'direct';
const REFERRAL = 'referral';
const SEARCH = 'search';
const OPENCENTER = 'openCenter';

// 访问来源
const visitSource = [
  { label: '非网站', value: 'not_web' },
  { label: '直接访问', value: 'direct' },
  { label: '搜索引擎', value: 'search' },
  { label: '第三方网站', value: 'referral' }
];

const search = [
  { label: '百度', value: 'baidu' },
  { label: '360', value: '360search' },
  { label: '搜狗', value: 'sogou' },
  { label: '神马', value: 'sm.cn' },
  { label: '必应', value: 'bing' },
  { label: '谷歌', value: 'google' },
  { label: '今日头条', value: 'toutiaosearch' }
];
const searchList = search.map(val => val.value);

const open = [
  { label: 'sdk', value: 'appsdk' },
  { label: '微信公众号', value: 'weixin' },
  { label: '微信小程序', value: 'mini_program' },
  { label: '微博', value: 'weibo' },
  { label: '百度 bcp', value: 'baidu_bcp' },
  { label: '今日头条', value: 'toutiao' },
  { label: '头条小程序', value: 'toutiao_microapp' },
  { label: '快手', value: 'kuaishou' },
  { label: '抖音', value: 'douyin' },
  { label: '微信客服', value: 'weixin_kf' },
  { label: '腾讯广告', value: 'fmc' },
  { label: '快手企业号', value: 'quickhand' },
  { label: '小红书', value: 'redbook' },
  { label: '视频号', value: 'wx_video' }
];
const openList = open.map(val => val.value);

// source供来源判断和头像显示，文案映射
// 搜索项没有 yahoo! soso（搜狗旧称，兼容历史数据） baidu_web(不知道有用么)
const searchListSource = [...searchList, 'yahoo!', 'soso', 'baidu_web', 'fmc'];
// 来源字段叫sdk，后端筛选叫appsdk
const openListSource = [...openList, 'sdk', 'fmc'].filter(val => val !== 'appsdk');
const sourceMap = {
  '360search': '360搜索',
  baidu: '百度',
  google: '谷歌',
  sogou: '搜狗',
  sdk: 'SDK',
  sm: '神马',
  haosou: '好搜',
  bing: '必应',
  'yahoo!': '雅虎',
  weibo: '微博',
  wechat: '微信',
  weixin: '微信',
  direct: '直接访问',
  unknown: '未知',
  toutiao: '今日头条',
  toutiaosearch: '今日头条搜索',
  toutiao_microapp: '头条小程序',
  mini_program: '微信小程序',
  kuaishou: '快手',
  baidu_bcp: '百度',
  baidu_web: '百度',
  douyin: '抖音',
  direct_access: '直接访问',
  external_link: '第三方链接',
  weixin_kf: '微信客服',
  fmc: '腾讯广告',
  quickhand: '快手企业号',
  redbook: '小红书',
  wx_video: '视频号'
};

const sourceMain = [
  { label: '直接访问', value: DIRECT },
  { label: '第三方链接', value: REFERRAL }
];

const sourceOther = [
  { label: '搜索引擎', value: SEARCH, children: search },
  { label: '开放平台', value: OPENCENTER, children: open.filter(item => ['redbook', 'douyin', 'quickhand', 'wx_video'].includes(item.value)) }
];

const source = [...sourceMain, ...sourceOther];

// 原有sourcetype查询
const sourceTypeConfigList = [...open];

const sourceTypeConfigMap = {};

const defaultWebSource = {
  sub_source_name: '',
  display_name: '默认接入网站'
};

sourceTypeConfigList.forEach(item => {
  sourceTypeConfigMap[item.value] = item;
});

const getSourceChildList = (treeList = [], parentIdList = [], returnAllChildren = false) => {
  let list = [];
  treeList.forEach(item => {
    // 如果有children就找children
    if (item.children && item.children.length) {
      // 是否已经选中
      let hasChecked = parentIdList.includes(item.value);
      if (returnAllChildren) {
        hasChecked = true;
      }
      const findList = getSourceChildList(item.children, list.concat(parentIdList), hasChecked);
      list = list.concat(findList);
    } else if (returnAllChildren || parentIdList.includes(item.value)) {
      list.push(item.value);
    }
  });
  return list;
};

const allList = [...search, ...open, ...source];
const allMap = allList.reduce((prev, now) => {
  return {
    ...prev,
    [now.value]: now.label
  };
}, {});

const getSourceTreeData = source =>
  source.map(val => {
    const { children } = val;
    let newChild = children || [];
    if (children && children.length) {
      newChild = children.map(val => ({
        ...val,
        key: val.value
      }));
    }
    return {
      ...val,
      key: val.value,
      children: newChild
    };
  });
const sourceTreeData = getSourceTreeData(source);

// 通过label 改变某项的值
// 因为 appsdk 和 sdk
// [{label: 'sdk', value: 'appsdk'}]
const changeTreeDataValueByLabel = ({ newValue }) => {
  const mapFunc = list => {
    return list.map(val => {
      const newItem = newValue.find(newItem => newItem.label === val.label);
      if (newItem) {
        return {
          ...val,
          value: newItem.value
        };
      }
      return val;
    });
  };
  const filterSearch = mapFunc(search);
  const filterOpen = mapFunc(open);
  const filterSourceMain = mapFunc(sourceMain);
  const otherSource = [
    { label: '搜索引擎', value: 'search', children: filterSearch },
    { label: '开放平台', value: 'openCenter', children: filterOpen }
  ];
  const filterSourceOther = mapFunc(otherSource);

  return [...filterSourceMain, ...filterSourceOther];
};

// 通过value 去掉某些项
const exceptSourceTreeDataByValue = ({ exceptValue, sourceTreeData }) => {
  if (!exceptValue || !exceptValue.length) {
    return sourceTreeData;
  }
  const result = [];
  sourceTreeData.forEach(val => {
    if (!exceptValue.includes(val.value)) {
      if (val.children && val.children.length) {
        const newChildren = val.children.filter(val => !exceptValue.includes(val.value));
        result.push({
          ...val,
          children: newChildren
        });
      } else {
        result.push(val);
      }
    }
  });
  return result;
};

export default {
  DIRECT,
  REFERRAL,
  SEARCH,
  OPENCENTER,
  search,
  open,
  searchList,
  openList,
  sourceMain,
  source,
  defaultWebSource,
  sourceTreeData,
  sourceTypeConfigList,
  sourceTypeConfigMap,
  getSourceChildList,
  allList,
  allMap,
  exceptSourceTreeDataByValue,
  changeTreeDataValueByLabel,
  searchListSource,
  openListSource,
  sourceMap,
  visitSource
};
